import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IProviderContact extends IModelBase {
  PhoneNumberId: number
  EmailAddressId: number
}

@Injectable()
export class ProviderContactsODataService extends ODataService<IProviderContact> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'ProviderContacts'
  }
}
